document.addEventListener('DOMContentLoaded', function () {
   const menuLists = document.querySelectorAll('.wcl-header__menu, .wcl-header__mobile-menu');

   menuLists.forEach(function (menuList) {
      initMegaMenu(menuList);
   });

   function initMegaMenu(menuList) {
      const isOffcanvas = menuList.classList.contains('wcl-header__mobile-menu');

      // Get the container for the current menu.
      const scope = isOffcanvas
         ? (menuList.closest('.wcl-header__mobile') || menuList.parentElement)
         : (menuList.closest('.wcl-header__nav') || menuList.parentElement);

      const items = menuList.querySelectorAll(':scope > li');

      function closeItem(li) {
         li.classList.remove('wcl-is-open');

         const toggle = li.querySelector(':scope > .wcl-mega-toggle');
         const link = li.querySelector(':scope > .wcl-menu-item-link');

         if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
         }

         if (link) {
            link.setAttribute('aria-expanded', 'false');
         }

         if (isOffcanvas) {
            scope.classList.remove('wcl-drilldown-active');
            document.body.classList.remove('is-lock');
         }
      }

      function closeAll(except) {
         items.forEach(function (li) {
            if (li !== except) {
               closeItem(li);
            }
         });
      }

      function openItem(li) {
         closeAll(li);

         li.classList.add('wcl-is-open');

         const toggle = li.querySelector(':scope > .wcl-mega-toggle');
         const link = li.querySelector(':scope > .wcl-menu-item-link');

         if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
         }

         if (link) {
            link.setAttribute('aria-expanded', 'true');
         }

         if (isOffcanvas) {
            scope.classList.add('wcl-drilldown-active');
            document.body.classList.add('is-lock');
         }
      }

      items.forEach(function (li) {
         const toggle = li.querySelector(':scope > .wcl-mega-toggle');
         const link = li.querySelector(':scope > .wcl-menu-item-link');
         const panel = li.querySelector(':scope > .wcl-mega-menu');

         // Add the mobile panel header.
         if (panel) {
            const head = document.createElement('div');
            head.className = 'wcl-mega-menu__mobile-head';

            const backBtn = document.createElement('button');
            backBtn.type = 'button';
            backBtn.className = 'wcl-mega-menu__back';
            backBtn.setAttribute('aria-label', 'Back');
            backBtn.innerHTML =
               '<span class="wcl-mega-menu__back-icon" aria-hidden="true"></span>' +
               '<span>Back</span>';

            backBtn.addEventListener('click', function (e) {
               e.preventDefault();

               closeItem(li);

               if (link) {
                  link.focus();
               }
            });

            head.appendChild(backBtn);

            const parentHref = link ? link.getAttribute('href') : '';

            // Add a link to the parent page if it has a URL.
            if (link && parentHref && '#' !== parentHref) {
               const parentLink = document.createElement('a');

               parentLink.className = 'wcl-mega-menu__parent-link';
               parentLink.href = parentHref;

               parentLink.innerHTML =
                  '<span>' + link.textContent.trim() + '</span>' +
                  '<span class="wcl-mega-menu__parent-arrow" aria-hidden="true">' +
                  '<svg width="29" height="12" viewBox="0 0 29 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                  '<path d="M0 6H28M23 1L28 6L23 11" stroke="#1E0046" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                  '</svg>' +
                  '</span>';
               head.appendChild(parentLink);
            }

            panel.insertBefore(head, panel.firstChild);
         }

         if (toggle) {
            toggle.addEventListener('click', function (e) {
               e.preventDefault();
               e.stopPropagation();

               if (li.classList.contains('wcl-is-open')) {
                  closeItem(li);
               } else {
                  openItem(li);
               }
            });
         }

         if (link && panel) {
            link.addEventListener('click', function (e) {
               const href = link.getAttribute('href');
               const noUrl = !href || '#' === href;

               // On mobile, clicking the parent opens the submenu.
               // The parent page link is available inside the submenu.
               //
               // On desktop, the link works normally.
               // If there is no URL, clicking it opens the mega menu.
               if (isOffcanvas || noUrl) {
                  e.preventDefault();

                  if (li.classList.contains('wcl-is-open')) {
                     closeItem(li);
                  } else {
                     openItem(li);
                  }
               }
            });
         }


         /*
         * Close mega menu after clicking an anchor link.
         * The extra class temporarily overrides :hover and :focus-within.
         */
         if (!isOffcanvas && panel) {
            const anchorLinks = panel.querySelectorAll(
               '.wcl-mega-menu__col-link[href*="#"]'
            );

            anchorLinks.forEach(function (anchor) {
               anchor.addEventListener('click', function () {
                  closeItem(li);

                  li.classList.add('wcl-anchor-closing');

                  // Prevent :focus-within from reopening the mega menu.
                  anchor.blur();
               });
            });

            li.addEventListener('mouseleave', function () {
               li.classList.remove('wcl-anchor-closing');
            });
         }
      });

      // Close the current menu when clicking outside its container.
      document.addEventListener('click', function (e) {
         if (!scope.contains(e.target)) {
            closeAll();
         }
      });

      // Close the current menu with the Escape key.
      document.addEventListener('keydown', function (e) {
         if (e.key === 'Escape') {
            const openLi = menuList.querySelector(':scope > li.wcl-is-open');

            if (openLi) {
               closeItem(openLi);

               const openLink = openLi.querySelector(
                  ':scope > .wcl-menu-item-link'
               );

               if (openLink) {
                  openLink.focus();
               }
            }
         }
      });

      // Close the item when focus moves outside of it.
      items.forEach(function (li) {
         li.addEventListener('focusout', function () {
            window.requestAnimationFrame(function () {
               if (!li.contains(document.activeElement)) {
                  closeItem(li);
               }
            });
         });
      });
   }
});